// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallTime__call-time-container-e6d502 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.CallTime__time-eaf57d {
  display: flex;
  align-items: center;
  color: var(--addition-50);
  margin-top: var(--indent-8px);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/CallState/CallTime/CallTime.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,wBAAA;EACA,wCAAA;AACF","sourcesContent":[".call-time-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.time {\n  display: flex;\n  align-items: center;\n  color: var(--addition-50);\n  margin-top: var(--indent-8px);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"call-time-container": `CallTime__call-time-container-e6d502`,
	"callTimeContainer": `CallTime__call-time-container-e6d502`,
	"time": `CallTime__time-eaf57d`
};
module.exports = ___CSS_LOADER_EXPORT___;
